import { createSlice } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

const initialState = {
  mode: 'light'
}

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setThemeMode (state, action) {
      return {
        ...state,
        mode: action.payload
      }
    },
    toggleThemeMode (state) {
      return {
        ...state,
        mode: state.mode === 'light' ? 'dark' : 'light'
      }
    }
  }
})

const persistConfig = {
  key: 'theme',
  storage
}

export const { setThemeMode, toggleThemeMode } = themeSlice.actions

export const ThemeReducer = persistReducer(persistConfig, themeSlice.reducer)
